import React, { useEffect, useState } from "react";
import { fetchCrmReminderAnalytics } from "../../utils/crmReminderAnalyticsClient";

const CrmReminderStats = ({ visible = true }) => {
  const [stats, setStats] = useState(null);
  const [days, setDays] = useState(7);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    let cancelled = false;
    setLoading(true);
    fetchCrmReminderAnalytics(days).then((data) => {
      if (!cancelled) {
        setStats(data);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [visible, days]);

  if (!visible) return null;

  const totals = stats?.totals || {};
  const byPhase = totals.byPhase || {};
  const ackRate = stats?.rates?.ackRate;

  return (
    <div className="crm-reminder-stats">
      <div className="crm-reminder-stats__header">
        <strong>Reminder analytics</strong>
        <select
          value={days}
          onChange={(e) => setDays(Number(e.target.value))}
          className="crm-reminder-stats__select"
        >
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
        </select>
      </div>
      {loading && !stats ? (
        <p className="crm-reminder-stats__muted">Loading…</p>
      ) : (
        <div className="crm-reminder-stats__grid">
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Push</span>
            <span className="crm-reminder-stats__value">{totals.push ?? 0}</span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Email</span>
            <span className="crm-reminder-stats__value">{totals.email ?? 0}</span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Digests</span>
            <span className="crm-reminder-stats__value">{totals.digest ?? 0}</span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Ack rate</span>
            <span className="crm-reminder-stats__value">
              {ackRate != null ? `${ackRate}%` : "—"}
            </span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Primary</span>
            <span className="crm-reminder-stats__value">{byPhase.primary ?? 0}</span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Overdue</span>
            <span className="crm-reminder-stats__value">{byPhase.overdue ?? 0}</span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Acked</span>
            <span className="crm-reminder-stats__value">{totals.acknowledged ?? 0}</span>
          </div>
          <div className="crm-reminder-stats__card">
            <span className="crm-reminder-stats__label">Snoozed</span>
            <span className="crm-reminder-stats__value">{totals.snoozed ?? 0}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrmReminderStats;
